// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"FoolScreen_foolScreen__1cJ3T","controllers":"FoolScreen_controllers__3HK83"};